"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGrid = exports.StyledZGrid = void 0;
const React = __importStar(require("react"));
const utils = __importStar(require("./zGridUtils"));
const AppContext_1 = require("../../utils/AppContext");
const cacheTimes_1 = require("../../utils/cacheTimes");
const kendo_data_query_1 = require("@progress/kendo-data-query");
const customColumnMenu_1 = require("./customColumnMenu");
const ZExport_1 = require("../ZExport/ZExport");
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
const ZAlert_1 = require("../ZAlert/ZAlert");
const ll_1 = require("../../languages/ll");
const UserDefinedFields_1 = require("../../utils/userDefinedFields/UserDefinedFields");
const ZLoadingMask_1 = require("../ZLoadingMask/ZLoadingMask");
const errors_1 = require("../../errors/errors");
const utils_1 = require("../../utils/utils");
const kendo_react_common_1 = require("@progress/kendo-react-common");
const apis_1 = require("../../apis");
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
const styled_components_1 = __importDefault(require("styled-components"));
class ZGridComponent extends React.Component {
    constructor(props) {
        super(props);
        this.boundDataStateChangeHandler = this.handleDataStateChange.bind(this);
        this.boundColumnStateChangeHandler = this.handleColumnStateChange.bind(this);
        this.boundColumnFilterChangeHandler = this.handleColumnFilterChange.bind(this);
        this.boundColumnSortChangeHandler = this.handleColumnSortChange.bind(this);
        this.boundColumnMenuGenerator = this.columnMenu.bind(this);
        this.boundColumnsSubmitHandler = this.onColumnsSubmit.bind(this);
        this.issueAlert = null;
        this.rowRender = (trElement, dataItem) => {
            const trProps = {
                ...trElement.props,
                key: dataItem.Id,
                onDoubleClick: (event) => {
                    this.props.onDoubleClick &&
                        this.props.onDoubleClick(event, dataItem);
                }
            };
            return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
        };
        this.cacheContains = (odata) => {
            if (this.props.cache && odata in this.props.cache) {
                const record = this.props.cache[odata];
                if (record != undefined) {
                    const iat = record.iat;
                    if (iat + this.cacheDuration < new Date().valueOf() &&
                        this.props.setCache) {
                        delete this.props.cache[odata];
                        this.props.setCache(this.props.cache);
                        return false;
                    }
                    return true;
                }
            }
            return false;
        };
        this.processExportData = (data) => {
            const pFilter = this.props.filter;
            const sFilter = this.state.filter;
            const total = data ? ("total" in data ? data.total : data.length) : 0;
            return kendo_data_query_1.process(data ? ("data" in data ? data.data : data) : [], {
                filter: this.combineFilters(pFilter, sFilter),
                sort: this.state.sort,
                skip: 0,
                take: total
            });
        };
        // We'll eventually have to use the schema to generate these filters.
        // This is most evident for Date vs DateTime.
        this.parseODataSubFilter = (subFilter) => {
            const { operator } = subFilter;
            let value = subFilter.value;
            let field = (subFilter.field || "").replaceAll(".", "/");
            if (value && value.toISOString) {
                value = value.toISOString();
            }
            switch (operator) {
                case "eq":
                    return value
                        ? `(${field} eq ${value == "null" ? "'null'" : value})`
                        : "";
                case "neq":
                    return value
                        ? `(${field} ne ${value == "null" ? "'null'" : value})`
                        : "";
                case "contains":
                    return value ? `substringof('${value}',${field})` : "";
                case "doesnotcontain":
                    return value ? `(not substringof('${value}',${field}))` : "";
                case "startswith":
                    return value ? `startswith(${field}, '${value}')` : "";
                case "endswith":
                    return value ? `endswith(${field}, '${value}')` : "";
                case "isnull":
                    return `(${field} eq null)`;
                case "isnotnull":
                    return `(${field} ne null)`;
                case "isempty":
                    return `(${field} eq '')`;
                case "isnotempty":
                    return `(${field} ne '')`;
                case "gte":
                    return value ? `(${field} ge ${value})` : "";
                case "gt":
                    return value ? `(${field} gt ${value})` : "";
                case "lte":
                    return value ? `(${field} le ${value})` : "";
                case "lt":
                    return value ? `(${field} lt ${value})` : "";
                default:
                    return "";
            }
        };
        const { skip, take, sort, columns } = props;
        this.state = {
            skip: skip || 0,
            take: take || 10,
            sort,
            columns,
            dataResult: {
                data: [],
                total: 0
            },
            mask: this.props.pending || false
        };
        this.containerRef = React.createRef();
        this.cacheDuration =
            this.props.cacheDuration || cacheTimes_1.CacheTimes.FifteenMinutes;
        this.lastRequest = "";
        this.pendingRequest = "";
        this.cancelRequest = null;
        if (this.props.setGridInstance) {
            this.props.setGridInstance(this);
        }
    }
    componentWillReceiveProps(nextProps, _nextState) {
        const { filter, oDataFilter } = this.props;
        if (this.getFilter(filter, oDataFilter) !==
            this.getFilter(nextProps.filter, nextProps.oDataFilter)) {
            if (this.cancelRequest !== null) {
                this.cancelRequest();
                this.cancelRequest = null;
                this.pendingRequest = "";
            }
            this.setState({
                skip: 0,
                take: this.props.pageSize || 10
            });
        }
    }
    componentDidMount() {
        this.getData();
    }
    componentDidUpdate() {
        this.getData();
    }
    mask() {
        if (this.state.mask === false) {
            this.setState({
                mask: true
            });
        }
    }
    unmask() {
        if (this.state.mask) {
            this.setState({
                mask: false
            });
        }
    }
    refresh() {
        if (this.props.cache && this.props.setCache) {
            if (this.cancelRequest !== null) {
                this.cancelRequest();
                this.pendingRequest = "";
            }
            this.props.setCache({});
        }
        this.setState({
            skip: 0,
            take: this.props.pageSize || 10
        });
    }
    render() {
        const { ignoreColumns } = this.props;
        const { title, className, ...gridProps } = this.props;
        const { resizable, reorderable, filterable, style } = gridProps;
        const { columns, dataResult, ...state } = this.state;
        const uniqueId = kendo_react_common_1.guid();
        const setAxiosInstance = (axiosInstance) => {
            this.axiosInstance = axiosInstance;
            return true;
        };
        const setIssueAlert = (issueAlert) => {
            if (typeof issueAlert === "function") {
                this.issueAlert = issueAlert;
            }
            return true;
        };
        const setUDFContext = (context) => {
            this.udlsAndUDFs = context;
            return true;
        };
        const processData = (data) => {
            const pFilter = this.props.filter;
            const sFilter = this.state.filter;
            return kendo_data_query_1.process(data ? ("data" in data ? data.data : data) : [], {
                filter: this.combineFilters(pFilter, sFilter),
                sort: this.state.sort,
                skip: this.state.skip,
                take: this.state.take
            });
        };
        const getFilter = () => {
            if (this.props.data) {
                if (this.props.filter) {
                    if (this.state.filter) {
                        return {
                            filters: [this.state.filter, this.props.filter],
                            logic: "and"
                        };
                    }
                    return this.props.filter;
                }
                if (this.state.filter) {
                    return this.state.filter;
                }
            }
            return undefined;
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: className, id: `container-${uniqueId}`, ref: this.containerRef },
                title ? React.createElement("div", { className: "z-grid-title" }, title) : null,
                React.createElement(ll_1.LLConsumer, null, ({ languageId }) => (React.createElement(ZAlert_1.IssueAlertContext.Consumer, null, issueAlert => (React.createElement(UserDefinedFields_1.UDFConsumer, null, udfs => setUDFContext(udfs) && (React.createElement(AppContext_1.AppContext.Consumer, null, ({ apiClient, isMobile }) => setAxiosInstance(apiClient) &&
                    setIssueAlert(issueAlert) && (React.createElement(ZExport_1.ExportWrapper, { excelExport: gridProps.excelExport, getExportData: this.getExportData.bind(this) },
                    React.createElement(kendo_react_grid_1.Grid, Object.assign({ columnVirtualization: this.props
                            .columnVirtualization ||
                            false }, gridProps, state, { data: this.props.data
                            ? processData(this.props.data)
                            : this.state.dataResult, sort: this.state.sort ||
                            [], filter: getFilter(), skip: this.state.skip, take: this.state.take, pageable: typeof this.props
                            .pageable === "object"
                            ? {
                                ...this.props
                                    .pageable,
                                buttonCount: isMobile
                                    ? 4
                                    : undefined,
                                info: isMobile
                                    ? false
                                    : true
                            }
                            : this.props
                                .pageable === true
                                ? {
                                    buttonCount: isMobile
                                        ? 4
                                        : undefined,
                                    info: isMobile
                                        ? false
                                        : true
                                }
                                : this.props.pageable, onDataStateChange: this
                            .boundDataStateChangeHandler, onFilterChange: this
                            .boundColumnFilterChangeHandler, onSortChange: this
                            .boundColumnSortChangeHandler, onColumnReorder: this
                            .boundColumnStateChangeHandler, onColumnResize: this
                            .boundColumnStateChangeHandler, onRowClick: event => {
                            this.setState({
                                selectedItemId: event.dataItem.Id,
                                dataResult: {
                                    ...this.state
                                        .dataResult,
                                    data: this.state.dataResult.data.map(d => ({
                                        ...d,
                                        selected: d.Id ===
                                            event
                                                .dataItem
                                                .Id
                                    }))
                                }
                            });
                            this.props.onRowClick &&
                                this.props.onRowClick(event);
                        }, style: style || {
                            width: 1200,
                            height: 400
                        }, resizable: resizable || true, reorderable: reorderable || true, scrollable: this.props.scrollable ||
                            "scrollable", rowHeight: 40, rowRender: (trElement, dataItem) => this.rowRender(trElement, dataItem) }), columns
                        ? columns.map((column, idx) => {
                            let shouldIgnore = false;
                            if (ignoreColumns) {
                                if (ignoreColumns.indexOf(column.field ||
                                    "") !== -1) {
                                    shouldIgnore =
                                        true;
                                }
                            }
                            if (shouldIgnore) {
                                return null;
                            }
                            else {
                                return column.hide !==
                                    true ? (React.createElement(kendo_react_grid_1.GridColumn, Object.assign({ key: idx, resizable: column.resizable ||
                                        resizable, reorderable: column.reorderable ||
                                        reorderable, columnMenu: this
                                        .boundColumnMenuGenerator, headerClassName: className, className: className, filterable: column.filterable ||
                                        filterable, format: column.format ||
                                        utils.guessFormatForField(column.field), filter: column.filter ||
                                        utils.guessTypeForField(column.field), editor: column.editor ||
                                        utils.guessTypeForField(column.field) }, column, { title: this
                                        .props
                                        .localize ==
                                        false
                                        ? column.title
                                        : ll_1.ll({
                                            key: column.title ||
                                                column.field ||
                                                "",
                                            languageId
                                        }) }))) : null;
                            }
                        })
                        : null))))))))))),
            (this.props.pending ||
                (this.props.data === undefined && this.state.mask)) && (React.createElement(ZLoadingMask_1.ZLoadingMask, { containerSelector: `#container-${uniqueId} .k-grid` }))));
    }
    handleDataStateChange(e) {
        this.setState(e.dataState);
    }
    handleColumnStateChange(e) {
        const newColumns = (this.state.columns || []).map(column => {
            const matchingColumn = e.columns.find(c => c.field === column.field);
            return matchingColumn
                ? {
                    ...matchingColumn,
                    title: column.title
                }
                : column;
        });
        this.setState({
            columns: newColumns
        });
    }
    handleColumnFilterChange(e) {
        this.setState({
            filter: e.filter || undefined
        });
    }
    handleColumnSortChange(e) {
        this.setState({
            sort: e.sort || undefined
        });
    }
    onColumnsSubmit(columnsState) {
        const visibleCount = columnsState.filter(c => c.hide !== true).length;
        const newColumns = this.state.columns &&
            columnsState.map(column => {
                const matchingColumn = this.state.columns &&
                    this.state.columns.find(c => c.field === column.field);
                return matchingColumn
                    ? {
                        ...matchingColumn,
                        hide: column.hide,
                        width: this.containerRef && this.containerRef.current
                            ? this.containerRef.current.getBoundingClientRect()
                                .width / visibleCount
                            : undefined
                    }
                    : {
                        ...column,
                        width: this.containerRef && this.containerRef.current
                            ? this.containerRef.current.getBoundingClientRect()
                                .width / visibleCount
                            : undefined
                    };
            });
        this.setState({
            columns: newColumns
        });
    }
    columnMenu(props) {
        return (React.createElement(customColumnMenu_1.CustomColumnMenu, Object.assign({ onColumnsSubmit: this.boundColumnsSubmitHandler, columns: this.state.columns, className: this.props.className, ignoreColumns: this.props.ignoreColumns }, props)));
    }
    scrollToTop() {
        if (this.containerRef.current) {
            const elements = this.containerRef.current.getElementsByClassName("k-grid-content");
            const scrollContainer = elements[0];
            if (scrollContainer) {
                scrollContainer.scrollTop = 0;
            }
        }
    }
    getUrlString(endpoint, query) {
        if (!this.axiosInstance) {
            throw new Error("Axios not found");
        }
        let udfSelects = [];
        if (this.props.entity !== undefined && this.udlsAndUDFs) {
            const UDLsAndUDFs = this.udlsAndUDFs;
            const UDFs = UDLsAndUDFs.UserDefinedFields || [];
            const UDFNames = UDFs.filter(udf => !!udf.BindName &&
                udf.TableName &&
                //@ts-ignore
                udf.TableName.toLowerCase() === this.props.entity.toLowerCase()).map(udf => udf.BindName);
            udfSelects = lodash_1.default.compact(UDFNames);
        }
        let selects = this.props.select === undefined
            ? this.props.columns
                ? this.props.columns.map(c => c.field).filter(f => !!f)
                : []
            : this.props.select || [];
        selects = selects.concat(udfSelects);
        const select = selects.join(",");
        const expands = utils_1.getExpandsFromSelects(selects) || [];
        const expand = expands.join(",");
        const mappedRequest = {};
        query
            .split("&")
            .forEach(keyval => (mappedRequest[keyval.split("=")[0]] = keyval.split("=")[1]));
        return {
            url: endpoint,
            params: {
                $select: select,
                $expand: expand,
                $inlinecount: "allpages",
                ...mappedRequest
            }
        };
    }
    async fetchData(apiClient, endpoint, query) {
        return new Promise((resolve, reject) => {
            const { url, params } = this.getUrlString(endpoint, query);
            apiClient
                .request({
                method: "GET",
                url,
                params,
                cancelToken: new axios_1.default.CancelToken(c => {
                    this.cancelRequest = c;
                })
            })
                .then(resp => {
                if (resp.status === 200) {
                    if (typeof this.props.onDataRecieved === "function") {
                        const manipulatedResult = this.props.onDataRecieved(resp);
                        resolve(manipulatedResult);
                    }
                    else {
                        resolve({
                            data: resp.data.d.results,
                            total: resp.data.d.__count
                        });
                    }
                }
                else {
                    throw resp;
                }
            })
                .catch(error => {
                errors_1.displayAndLogErrorWithMessage(error, "GridFetchErrorMessage", this.issueAlert);
            })
                .finally(() => {
                this.cancelRequest = null;
                this.pendingRequest = "";
                this.unmask();
            });
        });
    }
    combineFilters(pFilter, sFilter) {
        const filter = {
            logic: "and",
            filters: []
        };
        if (pFilter !== undefined) {
            filter.filters.push(pFilter);
        }
        if (sFilter !== undefined) {
            filter.filters.push(sFilter);
        }
        return filter;
    }
    getData() {
        const { endpoint } = this.props;
        const pFilter = this.props.filter;
        const sFilter = this.state.filter;
        const filter = this.combineFilters(pFilter, sFilter);
        const filterString = this.getFilter(filter, this.props.oDataFilter);
        let query = kendo_data_query_1.toODataString({
            sort: this.state.sort,
            skip: this.state.skip,
            take: this.state.take
        });
        if (filterString) {
            query = `$filter=${filterString}${query ? "&" : ""}${query}`;
        }
        if (endpoint && this.axiosInstance) {
            const cacheKey = `${endpoint}?${query}`;
            if (cacheKey !== this.lastRequest) {
                this.lastRequest = cacheKey;
                if (this.cancelRequest !== null &&
                    this.pendingRequest.trim() !== "") {
                    this.cancelRequest();
                    this.cancelRequest = null;
                    this.pendingRequest = "";
                }
                if (this.props.cache && this.cacheContains(cacheKey)) {
                    const cachedResult = this.props.cache[cacheKey].results;
                    this.scrollToTop();
                    const newState = {
                        dataResult: cachedResult
                    };
                    this.setState(newState);
                }
                else {
                    this.pendingRequest = query;
                    this.mask();
                    this.fetchData(this.axiosInstance, endpoint, query).then(result => {
                        if (this.props.cache && this.props.setCache) {
                            this.props.setCache({
                                ...this.props.cache,
                                [cacheKey]: {
                                    iat: new Date().valueOf(),
                                    results: result
                                }
                            });
                        }
                        this.scrollToTop();
                        const newState = {
                            mask: false,
                            dataResult: result
                        };
                        this.setState(newState);
                    });
                }
            }
        }
    }
    getExportData() {
        const { endpoint } = this.props;
        const pFilter = this.props.filter;
        const sFilter = this.state.filter;
        const filter = this.combineFilters(pFilter, sFilter);
        const filterString = this.getFilter(filter, this.props.oDataFilter);
        let query = kendo_data_query_1.toODataString({
            sort: this.state.sort,
            take: 10000
        });
        if (filterString) {
            query = `$filter=${filterString}${query ? "&" : ""}${query}`;
        }
        if (endpoint && this.axiosInstance) {
            this.pendingRequest = query;
            return this.fetchData(this.axiosInstance, endpoint, query);
        }
        else {
            return Promise.resolve(this.props.data
                ? this.processExportData(this.props.data)
                : this.state.dataResult);
        }
    }
    parseODataFilter(filter) {
        if (!filter) {
            return "";
        }
        const { logic, filters } = filter;
        if (filters.length == 1) {
            let subFilter = filter.filters[0];
            if (subFilter.logic) {
                return this.parseODataFilter(subFilter);
            }
            else {
                return this.parseODataSubFilter(subFilter);
            }
        }
        else {
            var subFilters = filters.map(subFilter => {
                if (subFilter.logic) {
                    let newSubFilter = this.parseODataFilter(subFilter);
                    return newSubFilter ? `(${newSubFilter})` : "";
                }
                else {
                    return this.parseODataSubFilter(subFilter);
                }
            });
            return subFilters
                .filter((value) => {
                return value;
            })
                .join(` ${logic} `);
        }
    }
    getFilter(filter, oDataFilter) {
        let filterString = filter ? this.parseODataFilter(filter) : "";
        if (oDataFilter) {
            filterString = `${filterString}${filterString ? " and " : ""}${oDataFilter}`;
        }
        return filterString;
    }
}
ZGridComponent.defaultProps = {
    sortable: true
};
exports.StyledZGrid = styled_components_1.default(ZGridComponent) `
   font-family: ${props => props.theme["font-family"]};
   & .k-grid-norecords {
      display: ${props => (props.pending ? "none" : "table-row")};
      font-family: ${props => props.theme["font-family"]};
   }
   & .k-filter-row {
      display: none;
   }
   & .k-grid-header[style] {
      padding: 0px !important;
      & .k-header {
         padding: 8px 15px 8px 24px !important;
         background: #f5f5f5;
         font-weight: normal;
         color: ${p => p.theme["banner-background-color"]};
      }
   }
   & .k-grid tr.k-state-selected > td {
      color: ${p => p.theme["action-button-hover-text-color"]};
      background-color: ${p => p.theme["selected-background-color"]};
   }
   & .k-master-row {
      line-height: 18px;
   }
   & .k-grid-pager {
      font-family: ${props => props.theme["font-family"]};
      & a.k-state-selected {
         color: ${p => p.theme["action-button-hover-text-color"]};
         background-color: ${p => p.theme["selected-background-color"]};
      }
   }

   & .z-grid-title {
      font-weight: bold;
      font-family: ${props => props.theme["font-family"]};
      margin: 5px 5px 5px 5px;
   }
   & .k-icon {
      color: ${p => p.theme["app-link-color"]};
      &:hover,
      &:hover::before {
         color: ${p => p.theme["hover-color"]};
      }
      &:active,
      &:active::before {
         color: ${p => p.theme["active-color"]};
      }
   }
   .k-popup & {
      padding: 0px;
   }
   & .k-columnmenu-item,
   & .k-column-list-item,
   & .k-columnmenu-actions {
      background-color: #f5f5f5;
      &:hover,
      &:hover .k-icon {
         background-color: #f5f5f5;
         color: ${p => p.theme["hover-color"]};
      }
      &:active,
      &:active .k-icon {
         color: ${p => p.theme["active-color"]};
      }
      & .k-button {
         background-color: #ebebeb;
         &:hover {
            color: ${p => p.theme["hover-color"]};
         }
         &.k-primary {
            background-color: ${p => p.theme["app-link-color"]};
            &:hover {
               background-color: ${p => p.theme["hover-color"]};
               color: #ebebeb;
            }
            color: #ebebeb;
         }
      }
   }
`;
exports.ZGrid = (props) => {
    const appContextValue = React.useContext(AppContext_1.AppContext);
    const apiClient = apis_1.useApiClientWithGroupCorrelationId(appContextValue.apiClient);
    return (React.createElement(ZAlert_1.IssueAlertProvider, null,
        React.createElement(AppContext_1.AppContext.Provider, { value: { ...appContextValue, apiClient } },
            React.createElement(exports.StyledZGrid, Object.assign({}, props)))));
};
exports.default = exports.ZGrid;
//# sourceMappingURL=ZGrid.js.map